import React from 'react'
import OrderDetails from '../features/order/Components/OrderDetails'

const OrderDetailsPages = () => {
  document.title = "Order Details - Plant Seller";
  return (
    <OrderDetails />
  )
}

export default OrderDetailsPages